import React, { useState } from "react";
import Accordion from "../../../components/reuseable_comp/accordion/Accordion";

const MedicalFitness = () => {
  // inner accordion
  const [innerActiveIndex, setInnerActiveIndex] = useState(null);

  const handleInnerToggle = (index) => {
    setInnerActiveIndex(innerActiveIndex === index ? null : index);
  };
  return (
    <div className="inner-accordion-section" id="inner-accordion">
      <Accordion
        title="Medical Requirements - Directorate General of Shipping's Fitness Requirements for Sea Service "
        className="inner-accordion-cards"
        isActive={innerActiveIndex === 0}
        onClick={() => handleInnerToggle(0)}
      />
      {innerActiveIndex === 0 && (
        <div className="inner-accordion-content" id="medical-fitness">
          <p>
            To be declared fit for selection, a candidate must be in good mental
            and physical health and free from any deficiency likely to interfere
            with the efficient performance of duties. These medical requirements
            are laid down by D.G. Shipping and are subjected to change. The
            following features are to be particularly observed:
          </p>

          <h4 className="innerpage-subheading">1.Constitution</h4>
          <p>
            There should be no evidence of a weak constitution by way of
            imperfect development of muscles or serious malformation. Minimum
            height should be 157 centimeters with co-related weight and
            proportionate chest with a minimum 5-centimeter expansion.
          </p>

          <h4 className="innerpage-subheading">2.Skeletal System</h4>
          <p>
            There should be no disease or impairment of functions of bones or
            joints. The candidate should also be free from any contraction or
            deformity of the chest or any joint. There should also not be any
            abnormal curvatures of the spine, deformity of legs and feet like
            bowlegs, knock knees, flat feet. Neither should there be any
            instance of deformity of upper limbs, malformation of the head,
            deformity from fractures or depression of the skull. Healed
            fractures with a pin inside will also be disqualification.
          </p>

          <h4 className="innerpage-subheading">3.Ear, Nose, Throat</h4>
          <ul  className="page-content-lists">
            <li>
              There should be no impaired hearing, discharge from or disease of
              either ear, unhealed perforation of the tympanic membrane or signs
              of acute or chronic supportive otitis media or evidence of radical
              or modified radical mastoid operation and no congenital
              malfunction of the ear. Unaided average threshold is to be higher
              than 40 dB in both ears at 500,1000,2000, and 3000 Hz and / or
              functional speech discrimination less than 90% at 55 dB in both
              ears is required. A candidate should be able to hear a whisper at
              a distance of 5 meters on each side without using hearing aids.
            </li>
            <li>
              Candidates should not be afflicted with any disease of the bones
              and cartilage of the nose, nasal polypus or disease of
              naos-pharynx or accessory sinuses.
            </li>
            <li>
              There should not be any loss or decay of teeth to such an extent
              as to interfere with efficient mastication. There should also not
              be any evidence of any disease of the throat, palate, tonsils or
              gums or any disease or injury affecting the normal function of
              either temporo-mandibular joint. Individuals with severe pyorrhea
              will also be rejected.
            </li>
          </ul>

          <h4 className="innerpage-subheading">4.Speech</h4>
          <p>
            There should be no speech impediment or impairment like excessive
            stammering or a pronounced lisp.
          </p>

          <h4 className="innerpage-subheading">5.Lymphatic System</h4>
          <p>
            All candidates must have a normally functioning glandular system
            without signs of tubercular enlargement or abnormality due to other
            diseases in the neck or other parts of the body.
          </p>

          <h4 className="innerpage-subheading">6.Cardiovascular System</h4>
          <p>
            There should be no instance of cardiac or vascular disease.
            Electrocardiograms should be within normal limits. Systolic and
            diastolic blood pressure must not exceed 140 and 90 mm of Hg,
            respectively.
          </p>

          <h4 className="innerpage-subheading">7.Respiratory System</h4>
          <p>
            There should be no evidence of chronic or upper respiratory disease,
            tuberculosis or history of this disease. X-ray of the chest should
            be normal.
          </p>

          <h4 className="innerpage-subheading">8.Digestive System</h4>
          <p>
            There should be no evidence of any disease of the digestive system,
            and the liver and spleen should not be palpable. There should be no
            abdominal tenderness on palpation.
          </p>

          <h4 className="innerpage-subheading">9.Genitourinary System</h4>
          <p>
            The kidneys should not be palpable, enlarged or diseased. Candidates
            with albuminuria, glycosuria or blood (R.B.C) in urine will not be
            accepted. There should be no hernia or tendency thereto. Those who
            have been operated on for hernia may be declared fit provided:
          </p>
          <ul  className="page-content-lists">
            <li>
              One year has elapsed after the operation (documentary proof
              required).
            </li>
            <li>General tone of abdominal muscles is good</li>
            <li>
              There has been no recurrence of hernia or complications arising
              from the surgery.
            </li>
          </ul>
          <p>
            There should be no hydrocele, varicocele, spermatocele or any other
            abnormality of genital organs. There should not be any incidence of
            fistula and/or anal fissure, hemorrhoids (piles) or rectal polyps.
            There should be no active latent or congenital venereal disease.
            Candidates with un-descended tests retained in the inguinal canal or
            at the extra abdominal ring will not be accepted.
          </p>

          <h4 className="innerpage-subheading">10.Skin</h4>
          <p>
            There should be no skin disease except that of a temporary or
            trivial nature. Scars, which by their extent or position are likely
            to cause disability, are also unacceptable.
          </p>

          <h4 className="innerpage-subheading">11.Nervous System</h4>
          <p>
            There should be no history or evidence of mental disease of the
            candidate or in his family. Candidates have history of fits;
            incontinence of urine or enuresis will not be accepted. Mental or
            nervous irritability, abnormality of gait, defective functions of
            cranial nerves, non-co-ordination, motor or sensory dysfunction will
            be cause for disqualification.
          </p>

          <h4 className="innerpage-subheading">12.Eyesight</h4>
          <ul  className="page-content-lists">
            <li>
              Candidates must not have any degree of squint or any morbid
              condition of eyes or of eyelids that is liable to aggravate or
              recur. Neither should they exhibit symptoms of pressure of
              trachoma and iris complications or sequela. Candidates must
              possess good binocular vision (fusion faculty and full field of
              vision in both eyes). Movement of the eyeballs must be full in all
              direction, and the pupils should react normally to light and
              accommodation.
            </li>
            <li>
              Use of corrective lenses for eyesight is permitted but the maximum
              permissible limits, at entry, are 6/12 in each eye or 6/9 in
              better eye and 6/18 in other eye for distant unaided vision. Color
              blindness is not permitted.
            </li>
            <li>
              Normal color vision is to be tested by Ichihara test chart.
              Candidates may also be disqualified by reason of any other
              deficiency that in the opinion of the examining doctors will
              interfere with or compromise the individual's ability to properly
              function as an officer in the merchant navy.
            </li>
          </ul>

          <h4 className="innerpage-subheading">13.Other Test</h4>
          <p>
            In addition, at the time of the medical examination or subsequently
            at any time during the program, candidates may be asked to undertake
            Drugs and/or HIV tests.
          </p>

          <div className="page-content-note">
           
            <p><b>Note :</b>
              Candidates, in their own interests, it would be prudent to get the
              eyesight checked from a qualified Eye specialist as per the
              eyesight requirement of the courses. This will help candidates
              avoid any last-minute embarrassment during the admission round.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default MedicalFitness;
